import React from 'react'
import Dashboard from './Dashboard'
import Container from '@mui/material/Container';

const Home = ({user}) => {
  return (
    <Container maxWidth="false" disableGutters sx={{height: "92vh", width: "100vw"}}>
      <Dashboard user={user}/>
    </Container>
  )
}

export default Home
